import { getShServiceBasePath } from "./utils/envUtil";

export class Constants {
  static readonly JWT_KEY = "jwt";
  static readonly USERNAME_KEY = "username";
  static readonly LOGOUT_REASON_KEY = "logout_reason";

  static readonly REVIEW_LOCKED_ECG_ID_KEY = "review_locked_ecg";

  static readonly ECG_VIEW_PDF_TOKEN_KEY = "pdfToken";
  static readonly ECG_VIEW_SSO_TOKEN_KEY = "ssoToken";

  static readonly PRESCRIPTION_VIEW_TOKEN_KEY = "prescriptionToken";

  static readonly FORGOT_PASSWORD_TOKEN_USERNAME_KEY = "u";
  static readonly FORGOT_PASSWORD_TOKEN_MOBILE_KEY = "mobile";

  static readonly API_QA_BASE_PATH = "https://qaapi.smartheartservice.com";
  static readonly API_STAGING_BASE_PATH =
    "https://apitest.smartheartservice.com";
  static readonly API_PROD_BASE_PATH = "https://api.smartheartservice.com";

  static readonly SHSERVICE_QA_BASE_PATH = "https://qa.smartheartservice.com";
  static readonly SHSERVICE_STAGING_BASE_PATH = "https://test.smartheartservice.com";
  static readonly SHSERVICE_PROD_BASE_PATH = "https://smartheartservice.com";

  static readonly TABLE_ITEMS_PER_PAGE = 100;
  static readonly TABLE_ROWS_PER_SCROLL = 25;

  static readonly MIN_ZOOM_SCALE = 1;
  static readonly MAX_ZOOM_SCALE = 8;
  static readonly ZOOM_SCALE_STEP = 0.2;

  static readonly DATE_FORMAT = "MM/DD/YYYY";
  static readonly SECONDARY_DATE_FORMAT = "MMM D, YYYY";
  static readonly DATE_TIME_FORMAT = `${Constants.DATE_FORMAT} hh:mm A`;
  static readonly YEAR_FORMAT = "YYYY";
  static readonly API_DATE_FORMAT = "YYYY-MM-DD";

  static readonly ECG_UNREADABLE_FINDINGS_CODE_1 = "99";
  static readonly ECG_INVERTED_T_WAVES_FINDING_CODE = 15;
  static readonly ECG_AVR_LEAD_CODE = 4;

  static readonly OFFLINE_CHECK_URLS = [
    "https://httpbin.org/get",
    `${getShServiceBasePath()}/keepalive/`,
  ];

  static readonly UNIQUE_ID_QUERY_PARAM_NAME = "uniqueId";
}

export class RouteConstants {
  static readonly AUTH = "auth";
  static readonly LOGIN = "login";
  static readonly REGISTER = "register";
  static readonly CHANGE_PASSWORD = "change-password";
  static readonly FORGOT_PASSWORD = "forgot-password";
  static readonly RESET_PASSWORD = "reset-password";
  static readonly PATIENTS = "patients";
  static readonly ECGS = "ecgs";
  static readonly ECG_DETAILS = "ecg_details";
  static readonly REPORTS = "reports";
  static readonly MANAGEMENT = "management";
  static readonly MANAGEMENT_ENTITIES = "entities";
  static readonly MANAGEMENT_USERS = "users";
  static readonly SETTINGS = "settings";
  static readonly ORDERS = "orders";
  static readonly SUPPORT = "support";
  static readonly LIMITED = "limited";
  static readonly VIEW_ECG = "view-ecg";
  static readonly VIEW_PRESCRIPTION = "view-prescription";

  static readonly LOGIN_PATH = `/${RouteConstants.AUTH}/${RouteConstants.LOGIN}`;
  static readonly REGISTER_PATH = `/${RouteConstants.AUTH}/${RouteConstants.REGISTER}`;
  static readonly CHANGE_PASSWORD_PATH = `/${RouteConstants.AUTH}/${RouteConstants.CHANGE_PASSWORD}`;
  static readonly FORGOT_PASSWORD_PATH = `/${RouteConstants.AUTH}/${RouteConstants.FORGOT_PASSWORD}`;
  static readonly RESET_PASSWORD_PATH = `/${RouteConstants.AUTH}/${RouteConstants.RESET_PASSWORD}`;
  static readonly PATIENTS_PATH = `/${RouteConstants.PATIENTS}`;
  static readonly ECGS_PATH = `/${RouteConstants.ECGS}`;
  static readonly ECG_DETAILS_PATH = `${RouteConstants.ECGS_PATH}/:ecgId`;
  static readonly REPORTS_PATH = `/${RouteConstants.REPORTS}`;
  static readonly MANAGEMENT_PATH = `/${RouteConstants.MANAGEMENT}`;
  static readonly MANAGEMENT_ENTITIES_PATH = `/${RouteConstants.MANAGEMENT}/${RouteConstants.MANAGEMENT_ENTITIES}`;
  static readonly MANAGEMENT_USERS_PATH = `/${RouteConstants.MANAGEMENT}/${RouteConstants.MANAGEMENT_USERS}`;
  static readonly SETTINGS_PATH = `/${RouteConstants.SETTINGS}`;
  static readonly ORDERS_PATH = `/${RouteConstants.ORDERS}`;
  static readonly SUPPORT_PATH = `/${RouteConstants.SUPPORT}`;
  static readonly LIMITED_PATH = `/${RouteConstants.LIMITED}`;
  static readonly VIEW_ECG_PATH = `/${RouteConstants.VIEW_ECG}`;
  static readonly VIEW_PRESCRIPTION_PATH = `/${RouteConstants.VIEW_PRESCRIPTION}`;
}

export class ErrorConstants {
  static readonly LOGIN_BLOCKED_CODE = "1";
  static readonly PASSWORD_EXPIRED_CODE = "2";
  static readonly LOGIN_INVALID_CREDENTIALS_CODE = "401";
  static readonly CREATE_USER_WITH_EMAIL_ALREADY_IN_USE_CODE = "1000";
  static readonly SAVE_ECG_ALREADY_SAVED_BY_OTHER_REVIEWER_CODE = "2000";
  static readonly CREATE_STUDY_WITH_NAME_ALREADY_IN_USE_CODE = "3000";
  static readonly ECG_REVIEW_LOCKED = "4000";
  static readonly ECG_SENT_FOR_REVIEW = "4002";
}

export const mediaQueries = {
  xs: "(max-width: 575.98px)",
  sm: "(max-width: 767.98px)",
  md: "(max-width: 991.98px)",
  lg: "(max-width: 1334.98px)",
  xl: null,
};

export const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const passwordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[@#$!%*?&^_~])(?=.*\d)(?!.*[<>])(?=^.{8,}$).*$/gm;
export const numberPattern = /^[0-9]+$/;

export const CCHS_CALL_CENTER_PHONE_NUMBER = "302-623-1929";

export const DEFAULT_PHONE_COUNTRY_CODE = 'US';